// material ui componets
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

// components
import Button from "../../../common/button";

// types
import { MessageType } from "../../../../pages/payment/paymentPage";

// constats
import { BUTTON, PAY_CONTRACT } from "../../constants";

// styles
import styles from "../styles.module.css";
import resultStyles from "./styles.module.css";

interface Props {
  messageType: MessageType;
  handleSubmit: () => void;
}

const Result = ({ messageType, handleSubmit }: Props): JSX.Element => {
  return (
    <Box dir="rtl" className={styles.paymentMethodsContainer}>
      <Box className={resultStyles.topSection}>
        {messageType === MessageType.SUCCESS ? (
          <Box component="img" src="/assets/images/svg/tick.svg" />
        ) : (
          <Box component="img" src="/assets/images/svg/error.svg" />
        )}
        <Box className={resultStyles.topsection_wrapper}>
          <Typography className={styles.noPaymentMethodsTitle}>
            {messageType === MessageType.SUCCESS
              ? PAY_CONTRACT.TRANSACTION_ACCEPTED
              : PAY_CONTRACT.TRANSACTION_FAILED}
          </Typography>
          <Typography className={styles.noPaymentMethodsSubTitle}>
            {messageType === MessageType.SUCCESS
              ? PAY_CONTRACT.VALUE_PAID
              : PAY_CONTRACT.SOMETHING_WENT_WRONG}
          </Typography>
        </Box>
      </Box>
      {messageType === MessageType.SUCCESS && (
        <Grid container gap={2}>
          <Grid container spacing={2}>
            <Grid justifyContent="center" alignItems="center" xs={1.5}>
              <Box component="img" src="/assets/images/svg/step1.svg" />
            </Grid>
            <Grid xs={10.5}>
              <Typography className={resultStyles.steps}>
                {PAY_CONTRACT.STEP_1}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid justifyContent="center" alignItems="center" xs={1.5}>
              <Box component="img" src="/assets/images/svg/step2.svg" />
            </Grid>
            <Grid xs={10.5}>
              <Typography className={resultStyles.steps}>
                {PAY_CONTRACT.STEP_2}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid justifyContent="center" alignItems="center" xs={1.5}>
              <Box component="img" src="/assets/images/svg/step3.svg" />
            </Grid>
            <Grid xs={10.5}>
              <Typography className={resultStyles.steps}>
                {PAY_CONTRACT.STEP_3}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
      {messageType === MessageType.SUCCESS && (
        <Button onClick={handleSubmit}>{BUTTON.CLOSE}</Button>
      )}
      {messageType === MessageType.ERROR && (
        <Button onClick={handleSubmit}>{BUTTON.TRY_AGAIN}</Button>
      )}
    </Box>
  );
};

export default Result;
